var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 23,
    fill: "#FFEDE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2205 16H14.7795C13.7995 16 13 16.8579 13 17.9096V29.0904C13 30.1421 13.7995 31 14.7795 31H31.2205C32.2005 31 33 30.1421 33 29.0904V17.9096C33 16.8579 32.2005 16 31.2205 16ZM30.5887 17.3007L30.1115 17.702L22.9936 23.7629L22.8646 23.6522L15.4113 17.3007H30.5887ZM31.7879 29.0904C31.7879 29.4225 31.53 29.6993 31.2205 29.6993H14.7795C14.47 29.6993 14.2121 29.4225 14.2121 29.0904V17.9511L14.5603 18.2417L22.6196 25.119C22.8388 25.2989 23.1612 25.2989 23.3804 25.119L31.7879 17.9511V29.1042V29.0904Z",
    fill: "#FF4D00",
    stroke: "#FF4D00",
    strokeWidth: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.a64b08abbad3ef81ac56b433311076a7.svg";
export { ForwardRef as ReactComponent };